import { useCallback, useSyncExternalStore } from "react";

/**
 * 560px = --iq-bp-sm (spec 01, D9).
 * Returns false when matchMedia is missing (jsdom).
 */
function mediaList(query: string): MediaQueryList | null {
  if (typeof window === "undefined" || typeof window.matchMedia !== "function") {
    return null;
  }
  return window.matchMedia(query);
}

function serverSnapshot(): boolean {
  return false;
}

export function useMediaQuery(query: string): boolean {
  const subscribe = useCallback((onStoreChange: () => void) => {
    const media = mediaList(query);
    if (!media) return () => {};
    media.addEventListener("change", onStoreChange);
    return () => media.removeEventListener("change", onStoreChange);
  }, [query]);

  const getSnapshot = useCallback(
    () => mediaList(query)?.matches ?? false,
    [query],
  );

  return useSyncExternalStore(subscribe, getSnapshot, serverSnapshot);
}
